export default __webpack_public_path__ + "static/media/anna@3x.c5622464.png";